<template>
  <div>
    <b-container>
      <div class="mt-4 d-flex align-items-start justify-content-between">
        <back-arrow :title="$t('RDVle') + ' '  + this.formatDate(this.intervention['estimatedStartDate'])"/>
        <show-actions
          @clickOnEditBtn="clickOnEditBtn"
          @clickOnDeleteBtn="clickOnDeleteBtn"
          @clickOnGenerateReport="clickOnDownloadPDF"
          :generateReport="true"
        ></show-actions>
      </div>
      <div class="row">
        <div>
          <b-card class="mt-2 mb-4 mx-2 shadow-sm">
            <div class="row">

              <div class="col-12 col-md-6 col-lg-6 mb-4">
                <div class="bold-text">
                  {{ $t('intervention.Type') }}
                </div>
                <div>
                  {{ $t(getValueDeep("type", "fr")) }}
                </div>
              </div>

              <div class="col-12 col-md-6 col-lg-6 mb-4">
                <div class="bold-text">
                  {{ $t('intervention.Technician') }}
                </div>
                <div>
                  <a @click="goToTechnician()" href="javascript:void(0)" class="force-link"> {{ getValueDeep("technician", "firstName") }} {{ getValueDeep("technician", "lastName") }}</a>
                </div>
              </div>

              <div class="col-12 col-md-6 col-lg-6 mb-4">
                <div class="bold-text">
                  {{ $t('Applicant') }}
                </div>
                <div>
                  <a @click="goToClient()" href="javascript:void(0)" class="force-link">{{ intervention.applicant != null && intervention.applicant.isAgency ? getValueDeep("applicant", "agencyName") : getValueDeep("applicant", "name") }}</a>
                </div>
              </div>

              <div class="col-12 col-md-6 col-lg-6 mb-4">
                <div class="bold-text">
                  {{ $t('timeEstimate') }}
                </div>
                <div>
                  {{ timeEstimate }}
                </div>
              </div>

              <div class="col-6 mb-2">
                <div class="bold-text">
                  {{ $t('intervention.Status') }}
                </div>
                <div class="mt-2 mr-4" style="display: flex; flex-wrap: wrap;">
                  <div class="col-12 col-md-4 col-lg-4 state-buttons"
                       v-for="(status, index) in interventionStatus" :key="index">
                    <b-button
                      @click="updateStatus(status.value)"
                      :class="[{' active': statusSelected[status.value]},status.text]"
                      style="height: 100%;width: 90%;padding: 4px;font-size: 12px;font-weight:bold"
                      variant="primary">
                      {{ $t(status.text) }}
                      <check-icon v-if="statusSelected[status.value]" size="18"/>
                    </b-button>
                  </div>
                </div>
              </div>

              <div class="col-6"></div>

              <div class="col-12 col-md-6 col-lg-6 mb-4">
                <div class="bold-text">
                  {{ $t('AddressIntervention') }}
                </div>
                <div>
                  <a @click="goToAddressIntervention()" href="javascript:void(0)" class="force-link">{{ getValueDeep("addressIntervention", "name") }}</a>
                </div>
                <div v-if="this.intervention.addressIntervention != null && this.intervention.addressIntervention.additionalAddress != null">
                  <a @click="goToAddressIntervention()" href="javascript:void(0)" class="force-link">{{ getValueDeep("addressIntervention", "additionalAddress") }}</a>
                </div>
              </div>

              <div class="col-12 col-md-6 col-lg-6 mb-4">
                <div class="bold-text">
                  {{ $t('applicant.address') }}
                </div>
                <div>
                  {{ getValueDeep("billingAddress", "address") }} {{ getValueDeep("billingAddress", "postalCode") }} {{ getValueDeep("billingAddress", "city") }}
                </div>
                <div>
                  {{ this.intervention.billingAddress != null && this.intervention.billingAddress.additionalAddress != null ? this.intervention.billingAddress.additionalAddress : "" }}
                </div>
              </div>

              <div class="col-12 col-md-6 col-lg-6 mb-4">
                <div class="bold-text">
                  {{ $t('intervention.Description') }}
                </div>
                <div>
                  {{ getValue("description") }}
                </div>
              </div>
            </div>
          </b-card>

          <b-card class="mt-2 mb-4 mx-2 shadow-sm">
            <div v-if="getValueDeep('addressIntervention', 'tenant') !== 'N/A'" class="row">
              <div class="col-12 col-md-4 col-lg-4 mb-4">
                <div class="bold-text">
                  {{ $t('Tenant') }}
                </div>
                <div>
                  {{ getValueDeeper("addressIntervention", 'tenant', 'name') }}
                </div>
              </div>
              <div class="col-12 col-md-4 col-lg-4 mb-4">
                <div class="bold-text">
                  {{ $t('client.CellphoneNumber') }}
                </div>
                <div>
                  {{ getValueDeeper("addressIntervention", 'tenant', 'cellphone') }}
                </div>
              </div>
              <div class="col-12 col-md-4 col-lg-4 mb-4">
                <div class="bold-text">
                  {{ $t('client.PhoneNumber') }}
                </div>
                <div>
                  {{ getValueDeeper("addressIntervention", 'tenant', 'telephone') }}
                </div>
              </div>
            </div>
            <div v-if="getValueDeep('addressIntervention', 'owner') !== 'N/A'" class="row">
              <div class="col-12 col-md-4 col-lg-4 mb-4">
                <div class="bold-text">
                  {{ $t('Owner') }}
                </div>
                <div>
                  {{ getValueDeeper("addressIntervention", 'owner', 'name') }}
                </div>
              </div>
              <div class="col-12 col-md-4 col-lg-4 mb-4">
                <div class="bold-text">
                  {{ $t('client.CellphoneNumber') }}
                </div>
                <div>
                  {{ getValueDeeper("addressIntervention", 'owner', 'cellphone') }}
                </div>
              </div>
              <div class="col-12 col-md-4 col-lg-4 mb-4">
                <div class="bold-text">
                  {{ $t('client.PhoneNumber') }}
                </div>
                <div>
                  {{ getValueDeeper("addressIntervention", 'owner', 'telephone') }}
                </div>
              </div>
            </div>
            <div v-if="getValueDeep('addressIntervention', 'agency') !== 'N/A'" class="row">
              <div class="col-12 col-md-4 col-lg-4 mb-4">
                <div class="bold-text">
                  {{ $t('Agency') }}
                </div>
                <div>
                  {{ getValueDeeper("addressIntervention", 'agency', 'name') }}
                </div>
              </div>
              <div class="col-12 col-md-4 col-lg-4 mb-4">
                <div class="bold-text">
                  {{ $t('client.CellphoneNumber') }}
                </div>
                <div>
                  {{ getValueDeeper("addressIntervention", 'agency', 'cellphone') }}
                </div>
              </div>
              <div class="col-12 col-md-4 col-lg-4 mb-4">
                <div class="bold-text">
                  {{ $t('client.PhoneNumber') }}
                </div>
                <div>
                  {{ getValueDeeper("addressIntervention", 'agency', 'telephone') }}
                </div>
              </div>
            </div>
          </b-card>

          <b-card class="mt-2 mb-4 mx-2 shadow-sm">
            <div class="row">
              <div class="col-12 col-md-6 col-lg-6 mb-4">
                <div class="bold-text">
                  {{ $t('intervention.StartDate') }}
                </div>
                <div>
                  {{ getValueDate("estimatedStartDate") }}
                </div>
              </div>

              <div class="col-12 col-md-6 col-lg-6 mb-4">
                <div class="bold-text">
                  {{ $t('intervention.EndDate') }}
                </div>
                <div>
                  {{ getValueDate("estimatedEndDate") }}
                </div>
              </div>

              <div class="col-12 col-md-6 col-lg-6 mb-4" v-if="intervention.startDate != null && intervention.startDate !== 0">
                <div class="bold-text">
                  {{ $t('intervention.StartDateTechnician') }}
                </div>
                <div>
                  {{ getValueDate("startDate") }}
                </div>
              </div>

              <div class="col-12 col-md-6 col-lg-6 mb-4" v-if="intervention.endDate != null && intervention.endDate !== 0">
                <div class="bold-text">
                  {{ $t('intervention.EndDateTechnician') }}
                </div>
                <div>
                  {{ getValueDate("endDate") }}
                </div>
              </div>

            </div>
          </b-card>

          <b-card class="mt-2 mb-4 mx-2 shadow-sm">
            <div class="bold-text main-color mb-2" style="font-size: 110%;">
              {{ $t("Installation") }}
            </div>

            <div class="row">
              <div class="col-12 col-md-6 col-lg-4 mb-2" v-if="devices.length > 0">
                <div class="bold-text">
                  {{ $t('client.Device') }}
                </div>
                <div v-for="device in devices">
                  <a @click=goToDevice(device) href="javascript:void(0)">{{ device.name }} ({{device.year}})</a>
                </div>
              </div>

              <div class="col-12 col-md-6 col-lg-4 mb-2" v-if="addressIntervention.typeDevice != null">
                <div class="bold-text">
                  {{ $t('addressIntervention.TypeDevice') }}
                </div>
                <div>
                  {{ addressIntervention.typeDevice }}
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-12 col-md-6 col-lg-4 mb-2" v-if="addressIntervention.outdoorSensor != null">
                <div class="bold-text">
                  {{ $t('addressIntervention.OutdoorSensor') }}
                </div>
                <div>
                  {{ addressIntervention.outdoorSensor ? "Oui" : "Non"  }}
                </div>
              </div>
              <div class="col-12 col-md-6 col-lg-4 mb-2" v-if="addressIntervention.heatedFloor != null">
                <div class="bold-text">
                  {{ $t('addressIntervention.HeatedFloor') }}
                </div>
                <div>
                  {{ addressIntervention.heatedFloor ? "Oui" : "Non" }}
                </div>
              </div>
              <div class="col-12 col-md-6 col-lg-4 mb-2" v-if="addressIntervention.lowVentilation != null">
                <div class="bold-text">
                  {{ $t('addressIntervention.LowVentilation') }}
                </div>
                <div>
                  {{ addressIntervention.lowVentilation ? "Oui" : "Non" }}
                </div>
              </div>
              <div class="col-12 col-md-6 col-lg-4 mb-2" v-if="addressIntervention.roomThermostat != null && addressIntervention.roomThermostatType != null">
                <div class="bold-text">
                  {{ $t('addressIntervention.RoomThermostat') }}
                </div>
                <div>
                  {{ addressIntervention.roomThermostat ? addressIntervention.roomThermostatType : "Non" }}
                </div>
              </div>
              <div class="col-12 col-md-6 col-lg-4 mb-2" v-if="addressIntervention.roaiTap != null">
                <div class="bold-text">
                  {{ $t('addressIntervention.RoaiTap') }}
                </div>
                <div>
                  {{ addressIntervention.roaiTap ? "Oui" : "Non" }}
                </div>
              </div>
              <div class="col-12 col-md-6 col-lg-4 mb-2" v-if="addressIntervention.gasHose != null">
                <div class="bold-text">
                  {{ $t('addressIntervention.GasHose') }}
                </div>
                <div>
                  {{ addressIntervention.gasHose ? "Oui" : "Non" }}
                </div>
              </div>
              <div class="col-12 col-md-6 col-lg-4 mb-2" v-if="addressIntervention.extractorHood != null">
                <div class="bold-text">
                  {{ $t('addressIntervention.ExtractorHood') }}
                </div>
                <div>
                  {{ addressIntervention.extractorHood ? "Oui" : "Non" }}
                </div>
              </div>
              <div class="col-12 col-md-6 col-lg-4 mb-2" v-if="addressIntervention.fluePipe != null">
                <div class="bold-text">
                  {{ $t('addressIntervention.FluePipe') }}
                </div>
                <div>
                  {{ addressIntervention.fluePipe }}
                </div>
              </div>
              <div class="col-12 col-md-6 col-lg-4 mb-2" v-if="addressIntervention.condensateEvacuation != null">
                <div class="bold-text">
                  {{ $t('addressIntervention.CondensateEvacuation') }}
                </div>
                <div>
                  {{ addressIntervention.condensateEvacuation ? "Oui" : "Non" }}
                </div>
              </div>
              <div class="col-12 col-md-6 col-lg-4 mb-2" v-if="addressIntervention.pipesBehindBoiler != null">
                <div class="bold-text">
                  {{ $t('addressIntervention.PipesBehindBoiler') }}
                </div>
                <div>
                  {{ addressIntervention.pipesBehindBoiler ? "Oui" : "Non" }}
                </div>
              </div>
              <div class="col-12 col-md-6 col-lg-4 mb-2" v-if="addressIntervention.areaHouse != null">
                <div class="bold-text">
                  {{ $t('addressIntervention.AreaHouse') }}
                </div>
                <div>
                  {{ addressIntervention.areaHouse }}
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 mb-2 mt-2" style="font-size: 110%">
            <span v-if="addressIntervention.bathroomQuantity != null" class="mr-1">
              <span class="bold-text">{{ addressIntervention.bathroomQuantity }}</span> {{ $t('addressIntervention.bathroomQuantity') }}
            </span>
                <span v-if="addressIntervention.bathtubQuantity != null" class="mr-1">
              <span class="bold-text">{{ addressIntervention.bathtubQuantity }}</span> {{ $t('addressIntervention.bathtubQuantity') }}
            </span>
                <span v-if="addressIntervention.showerQuantity != null" class="mr-1">
              <span class="bold-text">{{ addressIntervention.showerQuantity }}</span> {{ $t('addressIntervention.showerQuantity') }}
            </span>
                <span v-if="addressIntervention.basinQuantity != null" class="mr-1">
              <span class="bold-text">{{ addressIntervention.basinQuantity }}</span> {{ $t('addressIntervention.basinQuantity') }}
            </span>
                <span v-if="addressIntervention.bidetQuantity != null" class="mr-1">
              <span class="bold-text">{{ addressIntervention.bidetQuantity }}</span> {{ $t('addressIntervention.bidetQuantity') }}
            </span>
                <span v-if="addressIntervention.sinkQuantity != null" class="mr-1">
              <span class="bold-text">{{ addressIntervention.sinkQuantity }}</span> {{ $t('addressIntervention.sinkQuantity') }}
            </span>
              </div>
            </div>
          </b-card>

          <b-card class="mt-2 mb-4 mx-2 shadow-sm" v-if="intervention.notes != null && intervention.notes[0] != null">
            <div class="row">
              <div class="col-12 col-md-6 col-lg-6 mb-4">
                <div class="bold-text">
                  {{ $t('WrittenNotes') }}
                </div>
                <div v-html="printDescription(intervention.notes[0].description)">
                </div>
              </div>
            </div>
          </b-card>
        </div>

        <b-card class="col-6 mt-2 mb-4 mx-2 shadow-sm">
            <!--region ajout de document-->
            <b-form-group
              class="bold-label"
              label="Photo ou document"
              label-for="file-input"
            >
              <b-form-file
                id="file-input"
                class="mt-1"
                accept="image/jpeg, image/png, .pdf, .docx, .odt, .doc"
                placeholder="Photo ou document..."
                drop-placeholder="Glisser le fichier ici"
                v-model="file.value"
              ></b-form-file>
            </b-form-group>

            <div v-if="this.file.preview != null">
              <div
                v-if="this.file.type === 'PHOTO'"
                class="mt-2 position-relative text-right"
              >
                <button @click="addFile" class="btn-icon add-photo-icon">
                  <device-floppy-icon/>
                </button>
                <button @click="removeFile" class="btn-icon remove-photo-icon">
                  <trash-icon/>
                </button>
                <img
                  class="preview"
                  :src="this.file.preview"
                  alt="Aperçu"
                >
              </div>

              <div v-if="this.file.type === 'DOCUMENT'" class="mt-2 position-relative">
                <file-text-icon/>
                <a :href=this.file.preview target="_blank">{{ this.file.value.name }}</a>
                <button @click="addFile" class="btn-icon add-photo-icon document">
                  <device-floppy-icon/>
                </button>
                <button @click="removeFile()" class="btn-icon remove-photo-icon document">
                  <trash-icon/>
                </button>
              </div>
            </div>
            <!--endregion-->

            <div class="col">
              <!--region pdf des appareils-->
              <div v-if="pdfEditables && pdfEditables.length > 0" class="bold-text main-color mt-4 mb-2">

                <!--region linked to device-->
                {{ $t('DeviceDocuments') }}
                <div v-for="device in devices" class="mr-0 mr-lg-2 mb-2 mb-lg-0 flex">
                  <div class="bold-text black-text mt-2 mb-2 ml-2" v-if="pdfEditables.findIndex(item => item.device != null && item.device.id === device.id) !== -1">
                    {{ device.name }}
                  </div>
                  <div v-for="fileIntervention in pdfEditables">
                    <div v-if="fileIntervention.device != null && fileIntervention.device.id === device.id" class="mb-2" style="display: flex;flex-wrap: wrap">
                      <div class="col-1">
                        <file-text-icon size="28"/>
                      </div>
                      <a :href=fullFileUrl(fileIntervention.fileUrl) class="text-document col-10" target="_blank">{{ fileIntervention.name }}</a>
                      <button @click="removeFileDB(fileIntervention)" class="btn-icon remove-photo-icon listFile document">
                        <trash-icon size="25"/>
                      </button>
                    </div>
                  </div>
                </div>
                <!--endregion-->
                <!--region not linked to device-->
                <div class="bold-text black-text mt-2 mb-2 ml-2" v-if="pdfEditables.findIndex(item => item.device == null) !== -1">
                  {{ $t('NoDeviceDocuments') }}
                </div>
                <div v-for="fileIntervention in pdfEditables">
                  <div v-if="fileIntervention.device == null" class="mb-2" style="display: flex;flex-wrap: wrap">
                    <div class="col-1">
                      <file-text-icon size="28"/>
                    </div>
                    <a :href=fullFileUrl(fileIntervention.fileUrl) class="text-document col-10" target="_blank">{{ fileIntervention.name }}</a>
                    <button @click="removeFileDB(fileIntervention)" class="btn-icon remove-photo-icon listFile document">
                      <trash-icon size="25"/>
                    </button>
                  </div>
                </div>
                <!--endregion-->
                <hr>
              </div>
              <!--endregion-->
              <!--region DOCUMENTS-->
              <div v-if="fileInterventions && fileInterventions.length>0" class="bold-text main-color mt-4 mb-4">
                {{ $t("Documents") }}
                <div v-for="fileIntervention in fileInterventions" class="mr-0 mr-lg-2 mb-2 mt-2 mb-lg-0 flex">
                  <div v-if="fileIntervention.type === 'DOCUMENT'"
                       class="mb-2" style="display: flex;flex-wrap: wrap">
                    <div class="col-1">
                      <file-text-icon size="28"/>
                    </div>
                    <a :href=fullFileUrl(fileIntervention.fileUrl) class="text-document col-10" target="_blank">{{ fileIntervention.name }}</a>
                    <button @click="removeFileDB(fileIntervention)" class="btn-icon remove-photo-icon listFile document col-1">
                      <trash-icon/>
                    </button>
                  </div>
                </div>
                <hr>
              </div>
              <!-- endregion   -->
              <!--region PHOTOS -->
              <div v-for="fileIntervention in fileInterventions" class="mr-0 mr-lg-2 mb-2 mb-lg-0">
                <div v-if="fileIntervention.type === 'PHOTO'" class="mb-2">
                  <a :href=fullFileUrl(fileIntervention.fileUrl) class="" target="_blank">
                    <button class="btn-icon download-photo-icon listFile">
                      <download-icon/>
                    </button>
                  </a>
                  <button @click="removeFileDB(fileIntervention)" class="btn-icon remove-photo-icon listFile">
                    <trash-icon/>
                  </button>
                  <img
                    style="width: 100%"
                    :src="fullFileUrl(fileIntervention.fileUrl)"
                    @click="zoomOnImage(fullFileUrl(fileIntervention.fileUrl))"
                    alt="Photo associée à la note"
                    class="note-img"
                  >
                  <p>{{fileIntervention.comment}}</p>
                </div>
              </div>
              <!--endregion-->
            </div>
          </b-card>

      </div>
    </b-container>

    <!-- Modal Delete -->
    <intervention-delete-modal :selectedIntervention="intervention" @didDeleteIntervention="didDeleteIntervention()"></intervention-delete-modal>
    <file-intervention-delete-modal :file="fileIntervention" @didDeleteFileIntervention="didRemoveFileDB()"></file-intervention-delete-modal>

    <!-- Modal Zoom on image -->
    <zoom-on-image v-if="ui.zoomOnImageSrc !== null" :src="ui.zoomOnImageSrc" @didCloseZoomOnImage="didCloseZoomOnImage"></zoom-on-image>

    <!-- File download modal -->
    <b-modal
      id="loading-modal"
      :title="$t('generate.report.pdf.waiting.title')"
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
      hide-footer
    >
      <div class="d-flex flex-column align-items-center">
        <clock-icon class="mb-4 center" size="50"/>
        <p> {{ this.$t('generate.report.pdf.waiting.message') }} </p>
      </div>
    </b-modal>

  </div>
</template>

<script>
import api from '../../services/api'
import BackArrow from '../../components/b122/BackArrow'
import ShowActions from '../../components/b122/ShowActions'
import B122Table from '../../components/b122/B122Table'
import InterventionDeleteModal from './InterventionDeleteModal'
import FileInterventionDeleteModal from './FileInterventionDeleteModal'
import ZoomOnImage from '../../components/b122/ZoomOnImage'
import {dateUtils} from '../../mixins/utils'
import _ from 'lodash'

export default {
  name: 'InterventionShow',

  mixins: [dateUtils],

  components: {
    BackArrow,
    ShowActions,
    B122Table,
    InterventionDeleteModal,
    FileInterventionDeleteModal,
    ZoomOnImage
  },

  data () {
    return {
      statusSelected: {},
      addressIntervention: [],
      interventionStatusSelected: [],
      interventionStatus: [],
      interventionId: this.$route.params.interventionId,
      intervention: {},
      devices: [],
      fileInterventions: [],
      pdfEditables: [],
      fileIntervention: null,
      timeEstimate: '',
      ui: {
        zoomOnImageSrc: null
      },
      file: {
        value: null,
        type: null,
        preview: null
      }
    }
  },

  computed: {
    getValue () {
      return property => (this.intervention[property] || this.intervention[property] === false) ? this.intervention[property] : 'N/A'
    },
    getValueDate () {
      return property => (this.intervention[property] && this.intervention[property] !== 0) ? this.formatDate(this.intervention[property]) : 'N/A'
    },
    getValueDeep () {
      return (prop1, prop2) => ((this.intervention[prop1] || this.intervention[prop1] === false) &&
        (this.intervention[prop1][prop2] || this.intervention[prop1][prop2] === false)) ? this.intervention[prop1][prop2] : 'N/A'
    },
    getValueDeeper () {
      return (prop1, prop2, prop3) => ((this.intervention[prop1] || this.intervention[prop1] === false) &&
        (this.intervention[prop1][prop2] || this.intervention[prop1][prop2] === false) &&
        (this.intervention[prop1][prop2][prop3] || this.intervention[prop1][prop2][prop3] === false)) ? this.intervention[prop1][prop2][prop3] : 'N/A'
    }
  },

  mounted () {
    this.fetchData()
  },

  watch: {
    'file.value' () {
      if (this.file.value) {
        this.didAddFile()
      }
    }
  },

  methods: {
    // region fetch
    fetchData () {
      this.fetchIntervention()
      this.setInterventionStatus()
    },

    printDescription (text) {
      return text.replace(/\n/g, '<br>')
    },

    setInterventionStatus () {
      this.$store.getters.interventionStatus.map(status => {
        this.interventionStatus.push({value: status.id, text: `${status.name}`})
      })
    },

    setSelectStatus () {
      this.statusSelected = {}
      this.intervention.statuses.forEach(status => {
        this.statusSelected[status.id] = true
      })
    },

    fetchIntervention () {
      return api
        .get(`/intervention/${this.interventionId}`)
        .then(response => {
          this.intervention = response.data
          this.timeEstimate = this.getTimeEstimate(this.intervention.estimatedStartDate, this.intervention.estimatedEndDate)
          this.setSelectStatus()
          this.fetchDevices()
          this.fetchFileInterventions()
          this.fetchAddressIntervention()
        })
    },

    fetchDevices () {
      return api
        .get(`/device/getDevicesByAddressIntervention?addressInterventionId=${this.intervention.addressIntervention.id}`)
        .then(response => {
          this.devices = response.data
        })
    },

    fetchFileInterventions () {
      return api
        .get(`/fileIntervention/getFileInterventionsByInterventionId?interventionId=${this.intervention.id}`)
        .then(response => {
          this.fileInterventions = response.data
          // Enlève les valeurs de fileIntervention que l'on veut retrouver dans pdfEditable ;)
          this.pdfEditables = _.remove(this.fileInterventions, (value) => {
            return value.type === 'PDF_EDITABLE'
          })
        })
    },

    fetchAddressIntervention () {
      return api
        .get(`/addressIntervention/${this.intervention.addressIntervention.id}`)
        .then(response => {
          this.addressIntervention = response.data
        })
    },
    // endregion

    // region goTo
    goToTechnician () {
      this.$router.push({
        name: 'TechnicianShow',
        params: {
          technicianId: this.intervention.technician.id
        }
      })
    },

    goToClient () {
      this.$router.push({
        name: 'ClientShow',
        params: {
          clientId: this.intervention.applicant.id
        }
      })
    },

    goToAddressIntervention () {
      this.$router.push({
        name: 'AddressInterventionShow',
        params: {
          addressInterventionId: this.intervention.addressIntervention.id
        }
      })
    },

    goToDevice (device) {
      this.$router.push({
        name: 'DeviceShow',
        params: {
          deviceId: device.id,
          addressName: this.addressIntervention.name
        }
      })
    },

    // endregion

    clickOnEditBtn () {
      this.$router.push({
        name: 'InterventionEdit',
        params: {
          interventionId: this.intervention.id
        }
      })
    },

    clickOnDeleteBtn () {
      this.$bvModal.show('intervention-delete-modal')
    },

    didDeleteIntervention () {
      let interventionName = this.formatDate(this.intervention.estimatedStartDate)
      this.$router.push({
        name: 'InterventionIndex'
      }, () => {
        this.$nextTick(() => {
          this.successToast(this.$i18n.t('Intervention') + ' "' + interventionName + '" ' + this.$i18n.t('deleted'))
        })
      })
    },

    successToast (message) {
      this.$bvToast.toast(message, {
        autoHideDelay: 2000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true
      })
    },

    getTimeEstimate (estimatedStartDate, estimatedEndDate) {
      if (estimatedStartDate < estimatedEndDate && estimatedStartDate && estimatedEndDate) {
        let delta = (estimatedEndDate - estimatedStartDate) / 1000,
          hours = Math.floor(delta / 3600)
        delta -= hours * 3600
        var minutes = Math.floor(delta / 60) % 60
        delta -= minutes * 60
        return hours + 'h ' + minutes + 'm '
      }
      return 'N/A'
    },

    // region files
    didAddFile () {
      this.file.preview = URL.createObjectURL(this.file.value)
      let extension = this.checkExtension(this.file.value.name).toUpperCase()
      this.file.type = (extension !== 'JPG' && extension !== 'JPEG' && extension !== 'PNG') ? 'DOCUMENT' : 'PHOTO'
    },

    checkExtension (filename) {
      return filename.split('.').pop()
    },

    removeFile () {
      this.file.preview = null
      this.file.type = null
      this.file.value = null
      this.file.state = null
      this.file.invalidFeedback = null
    },

    fullFileUrl (fileUrl) {
      return process.env.SERVER_URL + fileUrl
    },

    zoomOnImage (imageSrc) {
      this.ui.zoomOnImageSrc = imageSrc
    },

    didCloseZoomOnImage () {
      this.ui.zoomOnImageSrc = null
    },

    removeFileDB (file) {
      this.fileIntervention = file
      this.$bvModal.show('file-intervention-delete-modal')
    },

    didRemoveFileDB () {
      this.fetchFileInterventions()
    },

    addFile () {
      var headers = { 'content-type': 'multipart/form-data' }

      let data = new FormData()
      if (this.file.value) {
        data.append('file', this.file.value)
      }
      data.append('interventionId', this.intervention.id)

      api({
        method: 'POST',
        url: `fileIntervention/addFileIntervention`,
        data: data,
        headers: headers
      }).then((response) => {
        this.removeFile()
        this.fetchFileInterventions()
      })
    },

    clickOnDownloadPDF () {
      this.$bvModal.show('loading-modal')

      var data = new FormData()
      data.append('interventionId', this.interventionId)

      api({
        method: 'POST',
        url: '/intervention/generateReportPDF',
        data: data
      })
        .then(response => {
          // --------- DOWNLOAD -----------
          let a = document.createElement('a')
          if (window.URL && window.Blob && ('download' in a) && window.atob) {
            let blob = this.base64ToBlob(response.data.base64, 'application/pdf')
            let url = window.URL.createObjectURL(blob)
            a.href = url
            a.download = response.data.fileName
            a.click()
            window.URL.revokeObjectURL(url)
          }
          this.$bvModal.hide('loading-modal')
        }).catch(() => {
          this.$bvModal.hide('loading-modal')
        })
    },

    base64ToBlob: function (base64, mimetype, slicesize) {
      if (!window.atob || !window.Uint8Array) {
        // The current browser doesn't have the atob function. Cannot continue
        return null
      }
      mimetype = mimetype || ''
      slicesize = slicesize || 512
      let bytechars = atob(base64)
      let bytearrays = []
      for (let offset = 0; offset < bytechars.length; offset += slicesize) {
        let slice = bytechars.slice(offset, offset + slicesize)
        let bytenums = new Array(slice.length)
        for (let i = 0; i < slice.length; i++) {
          bytenums[i] = slice.charCodeAt(i)
        }
        let bytearray = new Uint8Array(bytenums)
        bytearrays[bytearrays.length] = bytearray
      }
      return new Blob(bytearrays, {type: mimetype})
    },

    // endregion

    updateStatus: function (position) {
      let data = new FormData()
      data.append('statusIdToUpdate', position)
      data.append('interventionId', this.interventionId)
      api({
        method: 'POST',
        url: `intervention/updateStatus`,
        data: data
      })
        .then((response) => {
          api
            .get(`/intervention/${this.interventionId}`)
            .then(response => {
              this.intervention = response.data
              this.setSelectStatus()
            })
        })
    }
  }
}
</script>

<style scoped>

.black-text{
  color: var(--main-text-color);
}

.loading-screen{

}

.state-buttons{
  padding: initial;
  margin-bottom: 5px;
}

.Billable, .Billable:focus {
  background-color: var(--main-white) !important;
  color: #FA0207 !important;
  border-color: #FA0207 !important;
  border-radius: 5px !important;
  border-width: 3px !important;
}

.Billable.active, .Billable:hover, .Billable.active:focus {
  background-color: #FA0207 !important;
  color: var(--main-white) !important;
  border-color: #FA0207 !important;
}

.QuoteToBeMade, .QuoteToBeMade:focus {
  background-color: var(--main-white) !important;
  color: #FFA200 !important;
  border-color: #FFA200 !important;
  border-radius: 5px !important;
  border-width: 3px !important;
}

.QuoteToBeMade.active, .QuoteToBeMade:hover, .QuoteToBeMade.active:focus {
  background-color: #FFA200 !important;
  color: var(--main-white) !important;
  border-color: #FFA200 !important;
}

.RetakeIntervention, .RetakeIntervention:focus {
  background-color: var(--main-white) !important;
  color: #2BC545 !important;
  border-color: #2BC545 !important;
  border-radius: 5px !important;
  border-width: 3px !important;
}

.RetakeIntervention.active, .RetakeIntervention:hover, .RetakeIntervention.active:focus {
  background-color: #2BC545 !important;
  color: var(--main-white) !important;
  border-color: #2BC545 !important;
}

</style>



// WEBPACK FOOTER //
// src/views/intervention/InterventionShow.vue